import { UserDetailType } from "../stores/userDetailStore";

export const UserDetailCtx = {
    userDetail: null as null | UserDetailType,

    setUserDetail(userDetail: UserDetailType | null) {
        this.userDetail = userDetail;
    },
};